/**
 * PowerSync Transaction Facade — Electron Renderer
 *
 * Proxies get/execute calls to a single open write transaction held in the
 * main process for the lifetime of an ElectronPowerSyncFacade.writeTransaction
 * call — see electronDb.ts and powersyncHandlers.ts.
 */

import {
  isEmptyResultError,
  PowerSyncQueryResultLike,
  PowerSyncTransactionFacade,
  toQueryResultRows,
} from './facadeTypes';

export class ElectronTransactionFacade implements PowerSyncTransactionFacade {
  private readonly txId: string;

  constructor(txId: string) {
    this.txId = txId;
  }

  async execute(
    sql: string,
    params?: unknown[],
  ): Promise<PowerSyncQueryResultLike> {
    const result = await window.powersync!.txExecute(this.txId, sql, params);
    return {
      rowsAffected: result.rowsAffected,
      insertId: result.insertId,
      rows: toQueryResultRows(result.rows),
    };
  }

  async get<T = Record<string, unknown>>(
    sql: string,
    params?: unknown[],
  ): Promise<T> {
    try {
      return (await window.powersync!.txGet(this.txId, sql, params)) as T;
    } catch (err) {
      if (isEmptyResultError(err)) return undefined as T;
      throw err;
    }
  }
}
